// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
export class ReplaceSubRouteAction extends TypedAction(ActionType.ReplaceSubRoute) {
    loggingData() {
        return {
            subRoute: this.subRoute.join("/")
        };
    }
    constructor(subRoute, timestamp = Date.now()){
        super(), this.subRoute = subRoute, this.timestamp = timestamp;
    }
}
